import { useMemo } from "react";
import { type SelectOption } from "@purpur/select";

type UsePageSizeOptionsHook = {
  options: SelectOption[];
};

export const usePageSizeOptions = (availablePageSizes: number[]): UsePageSizeOptionsHook => {
  const options = useMemo(
    () =>
      availablePageSizes.map((pageSize: number) => ({
        label: `${pageSize}`,
        value: `${pageSize}`,
      })),
    [availablePageSizes]
  );

  return {
    options,
  };
};
